import {
    SliceFactory,
    FetchCollectionData,
    ApiCollectionResponse,
    FetchItemDataType,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as CollectionOpenSearchSliceApiConfigurationParameters,
    Configuration,
    CollectionOpenSearchApi,
    CollectionOpenSearchJsonldOpensearchCollectionRead,
    CollectionDeDossierApiApiCollectionsDossiersIdGetRequest,
    CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest,
} from '../../../openApi/ApiFormalite';
import { ORDERS_OPEN_SEARCH_SLICE_NAME, FORMALITES_REDUCER_NAME } from '../constants';

export type CollectionOpenSearchApiObject = CollectionOpenSearchJsonldOpensearchCollectionRead;

// todo llc changer les types
export type NestedOrderFormaliteOpenSearch = {
    id: number;
    libelle: string;
    prestationId: Array<number>;
    articleIds: Array<number>;
    documentsCount: number;
    missingDocumentsCount: number;
    optionsCount: number;
};

export type NestedOrderProcessesOpenSearch = {
    id: number;
    validatorId: number;
    validatorLabel?: string;
    validatorTypeId: number;
    validatorTypeLabel?: string;
    prestations: Array<number>;
    articles: Array<number>;
    statusId: number;
    statusLabel: string;
    statusCode: string;
    statusSortOrder: string;
    externalUrl: string;
    identifier: string;
};

export type CollectionOpenSearch = {
    formalites: Array<NestedOrderFormaliteOpenSearch>;
    validationProcesses: Array<NestedOrderProcessesOpenSearch>;
} & Record<string, unknown> &
    Omit<CollectionOpenSearchApiObject, 'formalites'>;

export const mapperOpenSearchOrder = function (collection: CollectionOpenSearch) {
    return {
        ...collection,
    } as CollectionOpenSearch;
};

export function createOrderOpenSearchSlice(
    configuration: CollectionOpenSearchSliceApiConfigurationParameters,
) {
    const conf = new Configuration(configuration);
    const api = new CollectionOpenSearchApi(conf);

    const fetchorderOpenSearchSliceCollection: FetchCollectionData<CollectionOpenSearch> = ({
        // search,
        pagination,
        orders,
        filters,
        preFilters,
    }) => {
        const options = undefined;
        let orderNumero: 'asc' | 'desc' | undefined;
        // let q: string | undefined;

        let orderPrescripteurLibelle: 'asc' | 'desc' | undefined;
        let orderOffreLibelle: 'asc' | 'desc' | undefined;

        const {
            clientId,
            numero,
            prescriberId,
            societeId,
            offerId,
            statutInvoceLibelle,
            statutQuoteLibelle,
            incompleteForBilling,
            demo,
        } = filters;

        let { critical } = preFilters;
        if (critical === 1) {
            critical = true;
        }

        // if (search && search !== '') {
        //     q = search;
        // }

        orders.forEach((order) => {
            if (order.field === 'numero') {
                orderNumero = order.value;
            }

            if (order.field === 'prescripteurLibelle') {
                orderPrescripteurLibelle = order.value;
            }

            if (order.field === 'offreLibelle') {
                orderOffreLibelle = order.value;
            }
        });

        const requestParameters: CollectionOpenSearchApiApiOpensearchCollectionsGetCollectionRequest =
            {
                page: pagination.page + 1,
                itemsPerPage: pagination.itemsPerPage,
                clientId: clientId as number[],
                critical: critical as boolean,
                numero: [numero as string],
                societeId: [societeId as number],
                prescripteurId: [prescriberId as number],
                statutInvoceLibelle: [statutInvoceLibelle as string],
                statutQuoteLibelle: [statutQuoteLibelle as string],
                incompleteForBilling: incompleteForBilling as boolean,
                demo: demo as boolean,
                offerId: [offerId as number],
                orderNumero,
                orderPrescripteurLibelle,
                orderOffreLibelle,
            };

        return api
            .apiOpensearchCollectionsGetCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<CollectionOpenSearch>>;
    };

    const fetchorderOpenSearchSliceItem: FetchItemDataType<CollectionOpenSearch> = ({ idItem }) => {
        const requestParameters: CollectionDeDossierApiApiCollectionsDossiersIdGetRequest = {
            id: String(idItem),
        };

        return api
            .apiOpensearchCollectionsIdGet(requestParameters)
            .then((res) => res.data) as Promise<CollectionOpenSearch>;
    };

    const { slice: orderOpenSearchSlice, dataSourcesThunks: orderOpenSearchDataSourcesThunks } =
        SliceFactory.createSlice<CollectionOpenSearch, CollectionOpenSearch>(
            ORDERS_OPEN_SEARCH_SLICE_NAME,
            FORMALITES_REDUCER_NAME,
            [],
            fetchorderOpenSearchSliceCollection,
            fetchorderOpenSearchSliceItem,
            mapperOpenSearchOrder,
            {},
            undefined,
            [{ field: 'dateCreation', value: 'desc' }],
        );

    return { orderOpenSearchSlice, orderOpenSearchDataSourcesThunks };
}
